import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";
import { errorText } from "../lib/api";
import { LogoMark } from "../components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-[#0B0C10] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-[24px] border border-white/10 bg-[#12141C] p-8">
        <LogoMark className="h-12 w-12" />
        <div>
          <h1 className="font-display text-4xl font-extrabold uppercase text-white">Admin</h1>
          <p className="text-sm text-zinc-400">Fallsview Summer Concert Series</p>
        </div>
        <label className="block text-sm text-zinc-300">Email
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input mt-1" autoComplete="username" />
        </label>
        <label className="block text-sm text-zinc-300">Password
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input mt-1" autoComplete="current-password" />
        </label>
        {error && <p data-testid="admin-login-error" role="alert" className="text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-primary w-full justify-center">
          {busy && <Loader2 size={16} className="animate-spin" />} Sign In
        </button>
      </form>
    </main>
  );
}
